import { MessageDescriptor, defineMessages } from 'react-intl';
import { ContentWizard_AiArticlesStep } from './ai-articles/AiArticlesStep';
import { ContentWizard_UserArticleStep } from './user-article/UserArticleStep';
import { ContentWizard_SocialVersionsStep } from './social-versions/SocialVersionsStep';

export { useAiArticlesProgress, AiArticlesProgressProvider } from './ai-articles/AiArticlesStep';

/** Step ids for Content AI wizard. Labels are translated where steps are consumed. */
export const contentAiStepIds = ['ai-articles', 'user-article', 'social-versions'] as const;

/** Step label messages for Content AI wizard (extractor-friendly). */
export const contentAiStepLabelMessages: Record<
  (typeof contentAiStepIds)[number],
  MessageDescriptor
> = defineMessages({
  'ai-articles': {
    id: 'contentAi.steps.generateArticles',
    defaultMessage: 'Generar artículos',
  },
  'user-article': {
    id: 'contentAi.steps.editContent',
    defaultMessage: 'Editar contenido',
  },
  'social-versions': {
    id: 'contentAi.steps.adaptAndPublish',
    defaultMessage: 'Adaptar y publicar en redes',
  },
});

export const contentAiSteps = [
  {
    id: 'ai-articles' as const,
    message: contentAiStepLabelMessages['ai-articles'],
    Content: ContentWizard_AiArticlesStep,
  },
  {
    id: 'user-article' as const,
    message: contentAiStepLabelMessages['user-article'],
    Content: ContentWizard_UserArticleStep,
  },
  {
    id: 'social-versions' as const,
    message: contentAiStepLabelMessages['social-versions'],
    Content: ContentWizard_SocialVersionsStep,
  },
];
